/**
 * Shared Terms & Conditions / eConsent check.
 *
 * Works with both the full {@link IUser} object and the raw Auth0 profile
 * payload (which carries the same field names).  A user "needs T&C" when any
 * of the following is true (and the user is **not** an LFG internal user):
 *
 *  1. They are an SSO user with an incomplete profile – T&C not yet accepted,
 *     or placeholder first/last name still present.
 *  2. They have not accepted the Terms & Conditions.
 *  3. They have not accepted eConsent (and are not an internal user).
 */
const EMPTY_FIRST = 'empty_first_name';
const EMPTY_LAST = 'empty_last_name';
export function needsTermsAndConditions(user) {
    if (!user || user.isLfgUser) {
        return false;
    }
    const hasIncompleteSsoProfile = user.ssoUser &&
        (user.termsAndConditionsAccepted === undefined ||
            user.firstName?.toLowerCase() === EMPTY_FIRST ||
            user.lastName?.toLowerCase() === EMPTY_LAST);
    const hasNotAcceptedTerms = !user.termsAndConditionsAccepted;
    const hasNotAcceptedEConsent = user.elecConsentAcceptedDate === null && !user.userInternal;
    return Boolean(hasIncompleteSsoProfile || hasNotAcceptedTerms || hasNotAcceptedEConsent);
}
